<script>
import DefaultLayout from '@/components/DefaultLayout.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import HrmineChat from '@/components/lib/hrmine-chat.vue'

export default {
  name: 'AIChatView',
  components: { DefaultLayout, EventNavbar, HrmineChat },
  data() {
    return {
      chatPlaceholder: 'Stell eine Frage...',
      chatSubtitle: '',
      chatSuggestions: []
    }
  },
  computed: {
    isAuthenticated() {
      return !!this.$storage.getToken()
    },
    initialMessage() {
      return this.$route.query.search || ''
    }
  },
  async mounted() {
    if (this.isAuthenticated) {
      try {
        const { data } = await this.$api.get('/ai-chat/welcome-hints/')
        if (data.placeholders && data.placeholders.length) {
          this.chatSuggestions = data.placeholders.slice(0, 3)
          this.chatPlaceholder = data.placeholders[Math.floor(Math.random() * data.placeholders.length)]
        }
        if (data.subtitles && data.subtitles.length) {
          this.chatSubtitle = data.subtitles[Math.floor(Math.random() * data.subtitles.length)]
        }
      } catch {
        // keep defaults
      }
    }
  },
  methods: {
    async onSend(message, history) {
      try {
        const response = await this.$api.post('/ai-chat/chat/', { message, history })
        this.$refs.chat.addResponse(
          response.data.response || response.data.error,
          response.data.sources
        )
      } catch (error) {
        if (error.response && error.response.status === 429) {
          this.$refs.chat.addResponse('Zu viele Anfragen. Bitte warte einen Moment.')
        } else {
          console.error('Chat error:', error)
          this.$refs.chat.addResponse('Ein Fehler ist aufgetreten. Bitte versuch es erneut.')
        }
      }
    }
  }
}
</script>

<template>
  <default-layout>
    <event-navbar title="HRmine" />
    <!-- Anonymous -->
    <div v-if="!isAuthenticated" class="text-center py-5 px-3">
      <i class="bi bi-chat-dots text-primary display-4 d-block mb-3"></i>
      <h5>HRmine, Deine KI-Assistentin</h5>
      <p class="text-muted mb-3">Stell Fragen zu Events, Ausstellern, Sessions und Speakern &mdash; HRmine hilft dir weiter.</p>
      <router-link to="/login" class="btn btn-primary">
        <i class="bi bi-box-arrow-in-right me-1"></i> Anmelden
      </router-link>
    </div>
    <!-- Authenticated: useFetch=false, parent handles API via $api (JWT auth) -->
    <hrmine-chat v-else ref="chat" :use-fetch="false" :initial-message="initialMessage"
                 :placeholder="chatPlaceholder" :subtitle="chatSubtitle"
                 :suggestions="chatSuggestions"
                 @send="onSend" style="height: calc(100vh - 112px);" />
  </default-layout>
</template>
